import React from 'react'
import { servicesContext } from 'presentation/contexts/services'

export const useServices = () => React.useContext(servicesContext)
